import { store } from '@/store'

export default {
  //добавление контрагента
  customers_postcustomer(data, vue) {
    if (typeof store.state.customers.customers != 'undefined') {
      vue.$root.$emit('refresh-table', 'customers')
    }
  },

  //изменение контрагента
  customers_putcustomer(data) {
    if (typeof store.state.customers.customers != 'undefined') {
      store.state.customers.customers.forEach((customer, index) => {
        if (customer.id == data.data.id) store.commit('setStateObject', ['customers.customers.' + index, data.data])
      })
    }
  },

  //удаление контрагента
  customers_deletecustomer(data, vue) {
    if (typeof store.state.customers.customers != 'undefined') {
      vue.$root.$emit('refresh-table', 'customers')
    }
  },

  //изменение контактного лица
  customers_putcustomercontacts(data) {
    if (typeof store.state.customers.customer.contacts != 'undefined') {
      store.state.customers.customer.contacts.forEach((contact, index) => {
        if (contact.id == data.data.id) store.commit('setStateObject', ['customers.customer.contacts.' + index, data.data])
      })
    }
  },

  //добавление контактного лица
  customers_postcustomercontacts(data) {
    /*
    if (typeof store.state.customers.customer != 'undefined') {
      store.commit('addStateObject', ['customers.customer.contacts', data.data])
    }
    */
  },

  //удаление контактного лица
  customers_removecustomercontacts(data) {
    /*
    if (typeof store.state.customers.customer.contacts != 'undefined') {
      store.state.customers.customer.contacts.forEach((customer, index) => {
        if (customer.id == data.data.id) store.commit('deleteStateObject', ['customers.customer.contacts', index])
      })
    }
    */
  },



  //Добавление группы контрагентов
  customers_postcustomergroup(data, vue) {
    if (store.state.customers.groups) {
      vue.$root.$emit('refresh-table', 'customer-groups')
    }
  },

  //Изменение группы контрагентов
  customers_putcustomergroup(data) {
    if (store.state.customers.groups) {
      store.state.customers.groups.forEach((group, index) => {
        if (group.id == data.data.id) store.commit('setStateObject', ['customers.groups.' + index, data.data])
      })
    }
  },

  //Удаление группы контрагентов
  customers_removecustomergroup(data, vue) {
    if (store.state.customers.groups) {
      vue.$root.$emit('refresh-table', 'customer-groups')
    }
  }



}



// WEBPACK FOOTER //
// ./src/modules/customers/pusher.js